<template>
  <validation-provider
    :rules="required ? 'required' : null"
    name="customer_id"
    class="w-100"
    v-slot="{ errors }">
    <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
      <v-select
        :options="extendedCustomers"
        v-model="customer_id"
        :reduce="customer => customer.id"
        :filterBy="filterByForCustomers"
        :placeholder="placeholderText"
        label="name"
        @search="debouncedFetchCustomers">
        <template slot="no-options">
          <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
          <template v-if="emptyResults">{{ $t('customer.noCustomerMarchingPhraseFound') }}&hellip;</template>
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-center">
            {{ option.name }}
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center">
            {{ option.name }}
          </div>
        </template>
      </v-select>
    </div>
  </validation-provider>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'select-customer',
  props: [
    'customerID',
    'customerType',
    'showMe',
    'required'
  ],
  computed: {
    placeholderText () {
      return this.$t('customer.selectCustomer');
    },
    extendedCustomers () {
      if (this.showMe) {
        return [{
          id: 0,
          name: this.$t('ui.myOrders'),
          email: ''
        }].concat(this.customers);
      }

      return this.customers;
    }
  },
  watch: {
    customer_id (newValue) {
      let foundedCustomer = this.customers.filter(customer => customer.id === newValue);

      if (foundedCustomer && foundedCustomer[0]) {
        let langID = foundedCustomer[0].language_id;
        this.$bus.$emit('ui-select-customer-language-updated', langID);
        this.discounts.products = parseFloat(foundedCustomer[0].partner_discount_products);
        this.discounts.services = parseFloat(foundedCustomer[0].partner_discount_services);
        this.discounts.shipping = parseFloat(foundedCustomer[0].partner_discount_shipping);
      } else {
        this.discounts.products = 0;
        this.discounts.services = 0;
        this.discounts.shipping = 0;
      }

      this.$bus.$emit('ui-select-customer-updated', {
        customer_id: newValue,
        discounts: this.discounts
      });
    }
  },
  data () {
    return {
      customer_id: null,
      customers: [],
      emptyResults: false,
      discounts: {
        products: 0,
        services: 0,
        shipping: 0
      }
    }
  },
  mounted () {
    this.endpointBase = '/customer-panel/partner-customers';
    this.customer_id = this.customerID;

    if (this.customer_id) {
      this.prefetchCustomer(this.customer_id);
    } else {
      this.customer_id = null;

      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointBase + '/items',
        outputKey: 'customers',
        errorKey: 'loadCustomersError'
      });
    }

    this.$bus.$on('ui-select-customer-reset', this.resetValue);
  },
  methods: {
    filterByForCustomers (option, label, search) {
      return (option.name + ' ' + option.email).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    prefetchCustomer (customerID) {
      if (!customerID) {
        return;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointBase + '/item/' + parseInt(customerID, 10),
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        wrapResponseIntoArray: true,
        successAction: (result) => {
          this.customer_id = parseInt(customerID, 10);
          this.discounts.products = parseFloat(result[0].partner_discount_products);
          this.discounts.services = parseFloat(result[0].partner_discount_services);
          this.discounts.shipping = parseFloat(result[0].partner_discount_shipping);

          this.$bus.$emit('ui-select-customer-prefetched-discounts', this.discounts);
        },
        catchAction: (err) => {
          if (err && err.response && err.response.status === 404) {
            Vue.swal({
              title: this.$t('order.nonExistingCustomerTitle'),
              html: this.$t('order.nonExistingCustomerText'),
              type: 'warning',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            });

            this.resetValue();
          }
        }
      });
    },
    fetchCustomers (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = this.endpointBase + '/items';
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.customer_id !== 0 && this.customer_id !== null && searchPhrase === '') {
        endpointUrl = this.endpointBase + '/item/' + parseInt(this.customer_id, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointUrl,
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchCustomers: debounce(function (searchPhrase, loadingCallback) {
      this.fetchCustomers(searchPhrase, loadingCallback);
    }, 500),
    resetValue () {
      this.customer_id = null;
    }
  },
  beforeDestroy () {
    this.$bus.$off('ui-select-customer-reset', this.resetValue);
  }
}
</script>

<style lang="scss" scoped>
.is-v-select-wrapper > div {
  width: 100%;
}
</style>
